import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { greyScaleColors, semanticColors } from '../../Globals/styles';
import Radium from 'radium';

class ActivityDragPreview extends Component {
  render() {
		const { activityName, unread, isActive } = this.props;
    return (
      <div style={[styles.aktivityBox, isActive && styles.isActiveCard]} onClick={this.onClick}>
        <div style={styles.header}>
          <div style={styles.dragable}>
            <img src="/images/Drag_and_Drop.png" alt="dragNDrop" />
          </div>
          <h3 style={styles.h3}>{activityName}</h3>
          {unread ? <div style={styles.infoBtn}><i className="fa fa-align-left" style={styles.infoIcon}></i></div>: null}
        </div>
      </div>
    );
  }
}

var styles = {
  dragable: {
    position: 'absolute',
    left: '0',
    height: '40px',
    width: '40px',
    textAlign: 'center',
    lineHeight: '40px'
  },
  aktivityBox: {
    textAlign: 'center',
    width: '212px',
    height: '39px',
    padding: '0',
    position: 'relative',
    backgroundColor: greyScaleColors.greyLighter,
    borderRadius: '2px'
  },
  isActiveCard:{
    backgroundColor: semanticColors.infoLight
  },
  activityIsDragging:{
    height: '39px'
  },
  infoIcon : {
    marginLeft: '22px',
    marginTop: '4px',
    color: semanticColors.text
  },
  infoBtn : {
    position: 'absolute',
    right: '0',
    top: '0',
    width:'0',
    height:'0',
    zIndex: '2',
    borderStyle: 'solid',
    borderWidth: '0 40px 40px 0',
    borderColor: "transparent " + semanticColors.info + " transparent transparent"
  },
  header:{
    position: 'relative',
    width: '100%',
    padding: '0 30px'
  },
  h3:{
    height: '40px',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    lineHeight: '40px'
  }
}
	ActivityDragPreview.propTypes = {
		activityName: PropTypes.string.isRequired,
		isActive: PropTypes.bool.isRequired,
    unread: PropTypes.bool.isRequired
	};
export default Radium(ActivityDragPreview)



// WEBPACK FOOTER //
// ./src/App/Project/ActivityOverview/activityDragPreview.jsx